module.exports = __webpack_public_path__ + "img/IMAGE 2.d32d8375.png";